
import Vue, { PropType } from 'vue';
import EventBus, { Event } from '@/core/event-bus';

export default Vue.extend({
    name: 'ErrorNotification',

    props: {
        eventBus: {
            type: Object as PropType<EventBus>,
            required: true
        }
    },

    data() {
        return {
            show: false,
            message: ''
        };
    },

    mounted() {
        this.eventBus.on(Event.notification, this.onNotification);
    },

    methods: {
        onNotification(payload: unknown, context?: string) {
            if (context !== 'errorNotification' || typeof payload !== 'object') return;

            const { message, show } = payload as {
                message: string,
                show: boolean
            };

            this.message = message;
            this.show = show;
        }
    }
});
